import * as React from "react";
import Box from "@mui/material/Box";

export function formatElapsed(ms: number, showTenths = false) {
    const totalSec = Math.floor(ms / 1000);
    const min = Math.floor(totalSec / 60);
    const sec = totalSec % 60;
    if (min > 0) return `${min}m ${sec}s`;
    if (showTenths) {
        const tenths = Math.floor((ms % 1000) / 100);
        return `${sec}.${tenths}s`;
    }
    return `${sec}s`;
}

/** Ticks on its own so a running report does not re-render the page around it. */
export default function RunElapsed({running, startedAt, finalMs}: {running: boolean; startedAt: number | null; finalMs: number | null}) {
    const [tick, setTick] = React.useState(0);

    React.useEffect(() => {
        if (!running || startedAt == null) return;
        const id = window.setInterval(() => setTick((n) => n + 1), 100);
        return () => window.clearInterval(id);
    }, [running, startedAt]);

    if (startedAt == null && finalMs == null) return null;
    const ms = running && startedAt != null ? Math.max(0, Date.now() - startedAt) : (finalMs ?? 0);
    void tick;

    return (
        <Box sx={{color: "text.secondary", fontSize: 14, minWidth: 100}}>
            {running ? "Running: " : "Last run: "}
            {formatElapsed(ms, running)}
        </Box>
    );
}
